import React, { useRef } from 'react';
import { LINKS } from '../data/site';
import { HeroBackground } from './HeroBackground';
import { InquiryPanel } from './InquiryPanel';
export function Hero() {
  const sectionRef = useRef<HTMLElement>(null);
  return <section ref={sectionRef} className="relative isolate overflow-hidden bg-charcoal text-cream" aria-labelledby="hero-heading" data-id="element-180" data-mp="9lbhp5hdljfp">
      <div className="relative mx-auto grid max-w-[1240px] gap-8 px-5 py-10 sm:px-8 md:grid-cols-[minmax(0,1fr)_320px] md:items-center md:gap-8 lg:grid-cols-[minmax(0,1fr)_400px] lg:items-center lg:gap-14 lg:py-12" data-id="element-181" data-mp="1297ahz3tqr77">
        <div className="max-w-[560px]" data-id="element-182" data-mp="sai5h6x1118d">
          <h1 id="hero-heading" className="font-display text-[42px] font-bold uppercase leading-[0.95] tracking-[-0.01em] text-white sm:text-[56px] md:text-[48px] lg:text-[68px]" data-id="element-183" data-mp="s9ghy2ytqm9r">
            Metal shaping tools.
            <br data-id="element-184" data-mp="381xkux4z309n" />
            <span className="text-fred" data-id="element-185" data-mp="381e1dbzoc3ti"><span className="whitespace-nowrap" data-id="element-186" data-mp="3814alm6t1smr">Hands-on</span>{' '}<span className="whitespace-nowrap" data-id="element-187" data-mp="3j7zc59vbxccg">know-how.</span></span>
          </h1>
          <p className="mt-6 max-w-[48ch] text-[16px] leading-relaxed text-steel-200 sm:text-[17px]" data-id="element-188" data-mp="3o7bzdvq44lfk">
            Equip your shop, learn at the workbench, or bring a custom metalwork project to life. Get tools,
            training and practical guidance from the Fournier shop.
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-3" data-id="element-189" data-mp="30i15my76jrax">
            <a href={LINKS.shopAll} className="inline-flex min-h-[52px] items-center bg-fred px-5 font-display text-[18px] sm:px-7 sm:text-[20px] uppercase tracking-[0.06em] text-white transition-colors duration-150 ease-out hover:bg-fred-dark" data-id="element-190" data-mp="30gq1uydqijjt">
              Shop Metalworking Tools
            </a>
            <a href={LINKS.workshops} className="inline-flex min-h-[52px] items-center px-2 font-display text-[20px] uppercase tracking-[0.06em] text-white underline decoration-white/30 underline-offset-8 transition-colors duration-150 ease-out hover:decoration-fred" data-id="element-191" data-mp="2hin9qapw46hs">
              Explore Workshops
            </a>
          </div>
        </div>

        <InquiryPanel data-id="element-192" data-mp="ic89fikzqczf" />
      </div>

      <HeroBackground sectionRef={sectionRef} data-id="element-193" data-mp="id9soac5u5s8" />
    </section>;
}